import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '../../services/api'

export const useArticles = (sessionId: string | null, page: number = 1, pageSize: number = 20) => {
  return useQuery({
    queryKey: ['articles', 'session', sessionId, page, pageSize],
    queryFn: () => sessionId ? dashboardApi.getArticlesBySession(sessionId, page, pageSize) : Promise.resolve({ data: [], pagination: { current_page: 1, page_size: pageSize, total_count: 0, total_pages: 1, has_next: false, has_prev: false } }),
    enabled: !!sessionId, // Only fetch when we have a session ID
    staleTime: 1000 * 60 * 5, // Consider data stale after 5 minutes (matches global setting)
    retry: (failureCount, error) => {
      // Stop retrying after 3 attempts or if it's a 404 (session not found)
      if (failureCount >= 3) return false
      if (error && (error as any).response?.status === 404) return false
      return true
    },
  })
} 